export default __webpack_public_path__ + "static/media/sad.3cdb98d2.svg";